import { Table } from "react-bootstrap";
import { SearchIconSvg } from "../../assets/svg";
import { useEffect, useMemo, useState } from "react";
import { debounce } from "lodash";
import CustomPagination from "../../components/CustomPagination/Pagination";
import { getEmailLogs } from "../../api/customer.api";

const tableHeader = ['#', 'Email From', 'Email To', 'Email CC', 'Email Subject', 'Delivery Status', 'Mailed At', 'Delivered At'];

const EmailLogsPage: React.FC = () => {
  const [tableData, setTableData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  
  const handleSearchChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchText(value);
    debouncedFetchData(value);
  };

  const debouncedFetchData = useMemo(() => {
    return debounce((searchValue) => {
      currentPage === 1 ? fetchData(searchValue) : setCurrentPage(1);
    }, 400);
  }, [currentPage]);

  useEffect(() => {
    fetchData(searchText);
  }, [currentPage]);

  const fetchData = async (searchText: string) => {
    setLoading(true);
    const data = await getEmailLogs(searchText, currentPage);
    if (data?.status === 200) {
      setTableData([...data?.result?.result?.data]);
      setTotalPages(Math.ceil(data?.result?.result?.totalRecords / 15));
    }
    setLoading(false);
  };

  return (
    <div className="w-[100vw] h-full flex flex-col gap-3 items-center p-3">
      <h4 className="underline underline-offset-4">Email Logs</h4>
      <div className="flex items-center gap-2 min-w-fit w-1/5 search-global-cont">
        <SearchIconSvg />
        <input
          autoComplete="off"
          className="w-full text-base text-black font-normal focus-visible:outline-none"
          placeholder={`Search by Email To`}
          name={"search"}
          onChange={handleSearchChange}
          value={searchText}
        />
      </div>
      <div className="w-full">
        {!!tableData.length ?
        <Table striped bordered responsive>
          <thead className="text-lg">
          <tr className="whitespace-nowrap">
              {tableHeader.map((heading) => <th>{heading}</th>)}
          </tr>
          </thead>
          <tbody className="text-base">
          {tableData.map((emailInfo: any, index: number) => (
            <tr key={emailInfo?._id} className={`whitespace-nowrap font-light ${loading ? 'animate-pulse' : ''}`}>
              <td>{index + 1}</td>
              <td>{emailInfo?.emailFrom}</td>
              <td>{emailInfo?.emailTo}</td>
              <td>{!!emailInfo?.emailCc?.length ? emailInfo?.emailCc?.map((email: string) => { return <>{email}<br /></> }) : 'N/A'}</td>
              <td className="whitespace-normal">{emailInfo?.subject}</td>
              <td className="capitalize">{emailInfo?.deliveryStatus}</td>
              <td>
                {!!emailInfo?.eventHistory?.[0] ? <>
                {new Date(emailInfo?.eventHistory?.find((event: any) => event.type === 'request')?.date).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                }).toString()} <br/>
                {new Date(emailInfo?.eventHistory?.find((event: any) => event.type === 'request')?.date).toLocaleTimeString("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                }).toString()}
                </> : 'N/A'}
              </td>
              <td>
                {!!emailInfo?.eventHistory?.[1] ? <>
                {new Date(emailInfo?.eventHistory?.find((event: any) => event.type === 'delivered')?.date).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                }).toString()} <br/>
                {new Date(emailInfo?.eventHistory?.find((event: any) => event.type === 'delivered')?.date).toLocaleTimeString("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                }).toString()}
                </> : 'N/A'}
              </td>
            </tr>
          ))}
          </tbody>
        </Table> : 
        <p className="text-center my-2 text-muted">{loading ? "Loading..." : "No Emails Found"}</p>}
      </div>
      {!!tableData.length && <CustomPagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages}/>}
    </div>
  );
};

export default EmailLogsPage;
